export default "__VITE_ASSET__216IDPlz__"